export enum StreamEventType {
  CONNECTED = 'connected',
  START = 'start',
  MEDIA = 'media',
  MARK = 'mark',
  CLEAR = 'clear',
  STOP = 'stop',
}

export type MediaEvent = {
  event: StreamEventType.MEDIA;
  streamSid: string;
  sequenceNumber: string;
  media: {
    payload: string;
  };
};

export type MarkEvent = {
  event: StreamEventType.MARK;
  mark: {
    name: string;
    timestamp?: number;
    playedBytes?: number | null;
  };
};

export type StartEvent = {
  event: StreamEventType.START;
  streamSid: string;
  sequenceNumber: string;
  start: {
    callSid: string;
    mediaFormat: {
      encoding: string;
      sampleRate: number;
      channels: number;
    };
    outboundMediaFormat: {
      encoding: string;
      sampleRate: number;
      channels: number;
    };
    customParameters: Record<string, string>;
    caller: string;
  };
};

export type ConnectedEvent = {
  event: StreamEventType.CONNECTED;
  protocol: string;
  version: string;
};

export type ClearEvent = {
  event: StreamEventType.CLEAR;
  streamSid: string;
};

export type StreamEvent =
  | StartEvent
  | MediaEvent
  | MarkEvent
  | ConnectedEvent
  | ClearEvent;
